import "./activity-feed";
import "./admin";
import "./admin/reports";
import "./admin/stripe";
import "./admin/users";
import "./annual-planner";
import "./client-configuration";
import "./client-configuration-templates";
import "./client-goals";
import "./client-notes";
import "./competition";
import "./complex";
import "./custom-metrics";
import "./cycle";
import "./daily-stats";
import "./docs";
import "./door-access";
import "./exercise";
import "./exercise-metric";
import "./femaleCycle";
import "./flexible";
import "./habit-logs";
import "./news";
import "./notes";
import "./notification";
import "./nutrition";
import "./nutrition-tdee-override";
import "./organizations";
import "./plan-manager";
import "./program-metrics";
import "./automation-sending";
import "./automations";
import "./push-dashboard-defaults";
import "./snapshot";
import "./tasks";
import "./teams";
import "./templates";
import "./tour";
import "./threads";
import "./training-days";
import "./users";
import "./widgets";
import "./workflows";
import "./workout-folders";
import "./workout-stats";

export default () => {};
